import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from "../context/DataProvider";
import axiosMain from '../axiosMain';
import { BASE_URLS } from '../utils/baseUrls';
import CryptoJS from "crypto-js";

const VerifyPage = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const { setopenLoginModal, openLoginMessage, setopenLoginMessage } = useContext(DataContext);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const verifyUser = async () => {
      try {
        // Get query parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const encryptedUserId = urlParams.get('userid');
        const emailFromUrl = urlParams.get('email');

        if (encryptedUserId && emailFromUrl) {
          setUserId(encryptedUserId);
          setEmail(emailFromUrl);

          // Call the API to verify email
          const requestBody = {
            Email: decrypt(emailFromUrl),
            MobileNo: null,
            UserId: 0,
            UserDetailId: parseInt(decrypt(encryptedUserId)), // Replace with actual UserDetailId if needed
            DomainId: 0,
            // IPAddress: "::1",
            OTP: 0,
            // DomainURL: "https://beta.tendergpt.io"
          };

          const response = await axiosMain.post(
            BASE_URLS + '/Registration/UserEmailVerification',
            requestBody
          );

          setLoading(false);
          if (response?.data?.SuccessCode === 3) {
            setopenLoginMessage(response?.data?.SuccessMessage);
            setopenLoginModal(true);
            // Navigate to the home page
          } else if (response?.data?.SuccessCode === 2) {
            setopenLoginMessage(response?.data?.SuccessMessage);
            setopenLoginModal(true);
            setMessage(response?.data?.SuccessMessage);
          }

          else {
            setLoading(false);
            setMessage(response?.data?.SuccessMessage);
          }

        } else {
          setLoading(false);
          setopenLoginMessage('Invalid URL parameters.');
        }
        // navigate('/');
      } catch (error) {
        setLoading(false);
        setopenLoginMessage('Error calling the API.');
      }
    };

    verifyUser(); // Call the async function
  }, [setopenLoginModal, navigate]);



  function decrypt(cipherText) {
    const encryptionKey = "Secure#ttneo2@23!$esk@pi";
    const salt = CryptoJS.enc.Hex.parse("4976616e204d65647665646576"); // hex for your C# byte array

    // Base64 decode and replace spaces with +
    cipherText = cipherText.replace(/ /g, "+");

    // Derive key and IV using PBKDF2 (same as Rfc2898DeriveBytes)
    const keySize = 256 / 32; // 32 bytes
    const ivSize = 128 / 32;  // 16 bytes

    const derivedParams = CryptoJS.PBKDF2(encryptionKey, salt, {
      keySize: keySize + ivSize, // key + iv in one buffer
      iterations: 1000,          // default in .NET's Rfc2898DeriveBytes
      hasher: CryptoJS.algo.SHA1
    });

    const key = CryptoJS.lib.WordArray.create(derivedParams.words.slice(0, keySize));
    const iv = CryptoJS.lib.WordArray.create(derivedParams.words.slice(keySize, keySize + ivSize));

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Convert to UTF-16LE string (same as Encoding.Unicode in C#)
    const decryptedUtf8 = decrypted.toString(CryptoJS.enc.Latin1);
    const utf16Bytes = new Uint8Array(decryptedUtf8.length);
    for (let i = 0; i < decryptedUtf8.length; i++) {
      utf16Bytes[i] = decryptedUtf8.charCodeAt(i);
    }
    const decoder = new TextDecoder("utf-16le");
    return decoder.decode(utf16Bytes);
  }


  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <h1>Verification Status</h1>
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default VerifyPage;
